import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Page } from '../models/page';
import { PagesizeType } from '../../event/service/pagination/pagesize-type';
import { UserLocalStorageService } from '../../permission/services/user.local.storage.service';
import { ConsoleLogSubscriberService } from '../log/console-log-subscriber.service';
import { LogLevel, LogMessage } from '../log/log.service';

@Component({
  selector: 'pioneer-pagination-refresh',
  templateUrl: './pagination-refresh.component.html'
})
export class PaginationRefreshComponent<T> implements OnChanges, OnInit {

  @Input()
  pagesizeType: PagesizeType; // *required

  @Input()
  resultsPage: Page<T>;

  @Input()
  disablePagination = false;

  @Input()
  resetTable = false;

  @Input()
  elResultsPage: number[] = [10, 25, 50, 100];

  @Output()
  public updatePage: EventEmitter<{page: number, itemsPerPage: number}> = new EventEmitter<{page: number, itemsPerPage: number}>();

  selectedItemsPerPage;
  currentPageNumber = 1;

  constructor(private userLocalStorageService: UserLocalStorageService,
    private consoleLogSubscriberService: ConsoleLogSubscriberService
  ) { }

  ngOnInit() {
    if (this.pagesizeType === undefined) {
      throw new Error('The "paginatedList" input is undefined');
    } else {
      const actualSelectNumberPerPage = this.userLocalStorageService.getPagesize(this.pagesizeType);
      const existNumberPerPage = this.selectedNumberExist(actualSelectNumberPerPage);
      if (!existNumberPerPage) {
        this.onChangeItemsPerPage(this.elResultsPage[0]);
      } else {
        this.selectedItemsPerPage = actualSelectNumberPerPage;
      }
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.resetTable) {
      if (changes.resetTable.currentValue) {
        this.currentPageNumber = 1;
      }
    }

    if (changes.resultsPage && changes.resultsPage.currentValue !== changes.resultsPage.previousValue) {
      const pagesize = this.userLocalStorageService.getPagesize(this.pagesizeType);
      this.selectedItemsPerPage = this.resultsPage ? this.resultsPage.size : pagesize;
      this.userLocalStorageService.setPagesize(this.pagesizeType, this.selectedItemsPerPage);
    }
  }

  private selectedNumberExist(actualSelectNumberPerPage) {
    return this.elResultsPage.filter(el => el === actualSelectNumberPerPage).length > 0;
  }

  private logConsole(message) {
    this.consoleLogSubscriberService.log(
      new LogMessage(LogLevel.INFO, message)
    );
  }

  get firstPageItemNumber(): number {
    return (this.resultsPage.number * this.resultsPage.size) + 1;
  }

  get lastPageItemNumber(): number {
    return (this.resultsPage.number * this.resultsPage.size) + this.resultsPage.numberOfElements;
  }

  goToPage(pageNumber?: number) {
    const page = pageNumber ? pageNumber - 1 : 0;
    const itemsPerPage = this.selectedItemsPerPage;
    this.currentPageNumber = page + 1;
    if (!this.resetTable) {
      this.updatePage.emit({page, itemsPerPage});
    }
  }

  onChangeItemsPerPage(newItemsPerPage: number) {
    this.selectedItemsPerPage = newItemsPerPage;
    this.userLocalStorageService.setPagesize(this.pagesizeType, this.selectedItemsPerPage);
    this.goToPage();
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/pagination-refresh/pagination-refresh.component.ts